module.exports = __webpack_public_path__ + "static/jest-config-a27752ac8cc16ff7a89fa287c22a00ec.png";